
<div class="form-check d-block">
  <input type="checkbox" id="showCurrentYear" class="form-check-input" [(ngModel)]="showCurrentYear" (change)="toggleShowCurrentYear()">
  <label class="form-check-label" for="showCurrentYear"> {{ "urval.period.one-year-back" | translate }} </label>
</div>

@if (useYearChecks === true) {
  <!-- Alternativ "välj år-spann med checkboxar" -->
  @for (yearCheck of yearChecks; track yearCheck) {
    <div class="form-check">
      <input type="checkbox" id="{{yearCheck.year}}" class="form-check-input" [(ngModel)]="yearCheck.checked" [disabled]="yearCheck.disabled" (change)="yearWasChecked()">
      <label class="form-check-label" [class.disabled]="yearCheck.disabled" for="{{yearCheck.year}}"> {{yearCheck.year}} </label>
    </div>
  }
}

@if (!useYearChecks) {
  <!-- Alternativ "välj år med dropdown-lista" -->
  <hr />
  <div class="row mb-3">
    <div class="col">
      <label>{{ "urval.period.from" | translate }}</label>
      <select class="form-select form-select-sm" [(ngModel)]="fromYear" (change)="fromYearChanged()">
        <option [value]="undefined" disabled>-</option>
        @for (fromYearOption of fromYears; track fromYearOption) {
          <option [value]="fromYearOption">{{fromYearOption}}</option>
        }
      </select>
    </div>
    <div class="col">
      <label>{{ "urval.period.to" | translate }}</label>
      <select class="form-select form-select-sm" [(ngModel)]="toYear" (change)="toYearChanged()">
        <option [value]="undefined" disabled>-</option>
        @for (toYearOption of toYears; track toYearOption) {
          <option [value]="toYearOption">{{toYearOption}}</option>
        }
      </select>
    </div>
  </div>
}

<hr />

<div class="row" style="height: auto">

  <div class="col-12">
    <label>{{ "urval.period.from" | translate }}</label><br />
    <form class="form-inline">
      <div class="form-group">
        <div class="input-group">
          <input class="form-control" placeholder="yyyy-mm-dd" name="dpFrom"
            ngbDatepicker #dpFrom="ngbDatepicker" container="body"
            [(ngModel)]="modelFrom" (ngModelChange)="periodChange()"
            [minDate]="fromMinDate" [maxDate]="fromMaxDate" [startDate]="modelFrom" />
            <button class="input-group-addon" (click)="dpFrom.toggle()" type="button">
              <i class="text-white far fa-lg fa-calendar-alt" style="cursor: pointer"></i>
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="col-12">
      <label class="mt-2">{{ "urval.period.to" | translate }}</label><br />
      <form class="form-inline">
        <div class="form-group">
          <div class="input-group">
            <input class="form-control" placeholder="yyyy-mm-dd" name="dpTo"
              ngbDatepicker #dpTo="ngbDatepicker" container="body"
              [(ngModel)]="modelTo" (ngModelChange)="periodChange()"
              [minDate]="toMinDate" [maxDate]="toMaxDate" [startDate]="modelTo" />
              <button class="input-group-addon" (click)="dpTo.toggle()" type="button">
                <i class="text-white far fa-lg fa-calendar-alt" style="cursor: pointer"></i>
              </button>
            </div>
          </div>
        </form>
      </div>

    </div>